// We import css cause were using webpack
import '../scss/theme.scss';
import '@splidejs/splide/css';
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import Slider from './rangeSlider';
import Recommendations from './recommendations';
import Product from './product';
import Cart from './cart';
import 'range-slider-input/dist/style.css';

Alpine.plugin(intersect)
Alpine.plugin(focus)
window.Alpine = Alpine

import Carousel from './Carousel'
 
const jsSections = {
    'carousel': Carousel,
    'slider': Slider,
    'recommendations': Recommendations,
    'product': Product,
    'cart': Cart
}

document.addEventListener('DOMContentLoaded', () => {
    // Any global JS goes here, otherwise inline JS at the bottom
    const sections = document.querySelectorAll('.js-section');
    for (let i = 0; i < sections.length; i++) {
        const jsSectionType = sections[i].getAttribute('data-js-type')
        if(jsSectionType in jsSections) {
            let sectionInitalise = new jsSections[jsSectionType](sections[i]);
            sectionInitalise.init();
        }
    }
    
    console.log('Theme loaded');
    Alpine.start()
});
